export default class TimezoneUtil {
    static zeroPadding(num: number) {
        return ("00" + (num)).slice(-2)
    }
    static changeLocalTimeFormatString(date: Date) {
        const retDate = new Date(date);
        var y = retDate.getFullYear();
        var m = TimezoneUtil.zeroPadding(retDate.getMonth()+1);
        var d = TimezoneUtil.zeroPadding(retDate.getDate());
        var h = TimezoneUtil.zeroPadding(retDate.getHours());
        var mi = TimezoneUtil.zeroPadding(retDate.getMinutes());
        var s =  TimezoneUtil.zeroPadding(retDate.getSeconds());
        var result = y + "-" + m + "-" + d + " " + h + ":" + mi + ":" + s;
        return result;
    }
}